import { useAuthedImageUrl } from './useAuthedImageUrl';

// The cover photo (lowest position in the gallery) for a customer catalog
// item - what list/shop thumbnails show. Only fetched when hasImage is true.
export function useCatalogItemImageUrl(itemId: string | null | undefined, hasImage: boolean | undefined): string | null {
  const url = itemId && hasImage ? `/catalog/items/${itemId}/image` : null;
  return useAuthedImageUrl(url, ['catalog-item-image', itemId]);
}

// The cover photo for a master catalog item (MSP-wide template).
export function useMasterItemImageUrl(itemId: string | null | undefined, hasImage: boolean | undefined): string | null {
  const url = itemId && hasImage ? `/catalog/master-items/${itemId}/image` : null;
  return useAuthedImageUrl(url, ['master-item-image', itemId]);
}

// One specific photo in a customer item's gallery (edit-modal thumbnails).
export function useCatalogItemPhotoUrl(itemId: string, photoId: string): string | null {
  return useAuthedImageUrl(`/catalog/items/${itemId}/photos/${photoId}`, ['catalog-item-photo', itemId, photoId]);
}

// One specific photo in a master item's gallery (edit-modal thumbnails).
export function useMasterItemPhotoUrl(itemId: string, photoId: string): string | null {
  return useAuthedImageUrl(`/catalog/master-items/${itemId}/photos/${photoId}`, ['master-item-photo', itemId, photoId]);
}
